import {z} from 'zod';

/**
 * One offerable financing rate coordinate, without its rates. A down payment between brackets
 * floors onto the lower bracket of the same term and balloon; below the lowest one it is refused.
 */
export const FinancingCellSchema = z.object({
  termMonths: z.number(),
  downPaymentPercentage: z.number(),
  balloonPaymentPercentage: z.number().nullable(),
});
export type FinancingCell = z.infer<typeof FinancingCellSchema>;
